module.exports = __webpack_public_path__ + "img/hospital-bed-empty-thumb.66370325.jpg";